import { createTheme, makeStyles } from '@material-ui/core/styles';

export const theme = createTheme({
    shadows: ['none'],
    palette: {
        background: {
            default: '#F0F4F7',
            paper: '#fff',
        },
        text: {
            primary: '#434E68',
            secondary: '#434E68',
            disabled: '#090',
            hint: '#030',
        },
        primary: {
            light: '#434E68',
            main: '#434E68',
            dark: '#434E68',
            contrastText: '#000',
        },
        secondary: {
            light: '#FFE916',
            main: '#FFE916',
            dark: '#FFE916',
            contrastText: '#434F69',
        },
        actionText: {
            light: '#D2577F',
            main: '#D2577F',
            dark: '#D2577F',
            contrastText: '#ccc',
        },
        purpleButtons: {
            light: '#563AF2',
            main: '#563AF2',
            dark: '#563AF2',
            contrastText: '#ccc',
        },
        pinkHeading: '#D2577F',
        yellowButton: '#FFE916',
        appBackground: '#C6CAD1',
        tableHEaderBackground: '#F4F6F8',
        buttonPurple: '#563AF2',
    },
    typography: {
        fontFamily: 'gilroy-regular',
        fontSize: '12px',
        fontWeight: 500,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        letterSpacing: 0,
        lineHeight: '24px',
        tableHeaderText: {
            color: '#434E68',
            fontFamily: 'gilroy-medium',
            fontDize: '12px',
            fontWeight: '600',
            letterSpacing: '0',
            lineHeight: '24px',
        },
        tableBody: {
            color: '#434E68',
            fontFamily: 'gilroy-medium',
            fontDize: '12px',
            fontWeight: '500',
            letterSpacing: '0',
            lineHeight: '24px',
        },
        readonlyData: {
            color: '#979DAA',
            fontFamily: 'gilroy-medium',
            fontSize: '9px',
            lineHeight: '10px',
        },

        h1: {
            color: '#434F69',
            fontFamily: 'gilroy-medium',
            fontSize: '12px',
            fontWeight: '500',
            letterSpacing: '0',
            lineHeight: '30px',
        },
        h2: {
            color: '#434E68',
            fontFamily: 'gilroy-bold',
            fontSize: '16px',
            fontWeight: '500',
            letterSpacing: '0',
            lineHeight: '28px',
        },
    },
    overrides: {
        MuiDataGrid: {
            root: {
                backgroundColor: '#fff',
                '& .MuiDataGrid-cell': {
                    color: '#434E68',
                    fontFamily: 'gilroy-regular',
                    fontSize: '12px',
                    fontWeight: '500',
                    letterSpacing: '0',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'pre', // don't collapse double spaces
                    cursor: 'pointer',
                },
                '& .MUIDataGrid': {},
                '& .MuiDataGrid-columnHeaderWrapper': {
                    color: '#434E68',
                    fontFamily: 'gilroy-medium',
                    fontSize: '14px',
                    fontWeight: '600',
                    letterSpacing: '0',
                    backgroundColor: '#F4F6F8',
                },
                '& .MuiDataGrid-window': {},
                '& .MuiDataGrid-row': { cursor: 'pointer' },
            },
        },
        MuiCssBaseline: {
            '@global': {
                '@font-face': ['gilroy-medium'],
            },
        },
        MuiFilledInput: {
            root: {
                backgroundColor: 'rgba(255, 0, 0, 0.04)',
                '&$disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
            },
        },
        MuiInputLabel: {
            root: {
                zIndex: '99',
            },
            outlined: {
                transform: 'translate(14px, 11px) scale(1)',
            },
        },
        MuiOutlinedInput: {
            input: {
                padding: '0px',
            },
        },
        MuiSelect: {
            outlined: {
                padding: '12.5px 14px',
            },
        },
        MuiInputBase: {
            input: {
                padding: '0px',
                fontSize: '14px',
                '&::placeholder': {
                    color: 'pink',
                    fontSize: '14px',
                },
                '&:before': {
                    borderBottom: 'none',
                },
            },
        },
        MuiButtonBase: {
            // root: {
            //     '&:hover:active::after': {
            //         // recreate a static ripple color
            //         // use the currentColor to make it work both for outlined and contained buttons
            //         // but to dim the background without dimming the text,
            //         // put another element on top with a limited opacity
            //         content: '""',
            //         display: 'block',
            //         width: '100%',
            //         height: '100%',
            //         position: 'absolute',
            //         top: 0,
            //         right: 0,
            //         backgroundColor: 'currentColor',
            //         opacity: 0.3,
            //         borderRadius: 'inherit',
            //     },
            // },
        },
    },
    props: {
        MuiButtonBase: {
            // disable ripple for perf reasons
            disableRipple: true,
        },
    },
});

export const useStyles = makeStyles((theme) => ({
    input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        padding: '6.5px 14px',
        fontSize: 16,
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
        },
        "&::before": {
            content: 'none',
        },
        "&::after": {
        content: 'none',
        },
    },
    root: {
        color: '#434F69',
        display: 'flex',
        width: '100%',
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    browseContainer: {
        width: '300px',
        backgroundColor: '#fff',
        borderRight: '1px solid #eee',
        flex: '0',
        height: '100vh',
    },
    bodyContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: ' 100%',
        backgroundColor: 'rgb(242, 244, 246)',
        textAlign: 'left',
        width: '100%',
    },
    itemsPanel: {
        dipslay: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    contentWrapper: {
        display: 'flex',
        flex: '1',
        width: '100%',
        border: '1px solid #333',
        backgroundColor: '#cce',
    },
    debugWrapper: {
        display: 'flex',
        flex: 0,
        minHeight: '200px',
        width: '100%',
        backgroundColor: '#cfc',
    },
    formBox: {
        margin: '4px 10px 6px 10px',
    },
    toolbarButton: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: '0px',
        marginRight: theme.spacing(1),
    },
    editPopupInput: {
        fontSize: '20px',
        width: '400px'
    },
    editPopupDesc: {
        border: '1px solid #D1CCCC',
        padding: '5px',
        marginLeft: '-15px',
        borderRadius: 4,
    },
    tagsBadge: {
        backgroundColor: '#D1517A',
        color: '#fff',
        marginTop: '11px',
        fontSize: '14px',
      },
    paper: {
        position: 'absolute',
        width: 900,
        height: 700,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 6,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        fontSize: '16px',
    },    
    searchBox: {
        padding: '10.5px 14px',
    },    
    horizontalBar: {
        background: '#D1CCCC',
        height: '1px',
        width: '100%',
        marginTop: '10px',
        marginBottom: '15px',
    },
}));
